import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withLoader from 'components/Shared/withLoader';

import { fetchReclamationDemandesEnlevement } from 'store/reclamation/detailsActions';

import ReclamationDrawerListItem from '../ReclamationDrawerListItem';

const ReclamationDrawerListItemWithLoader = withLoader(ReclamationDrawerListItem);


class DemandesEnlevementDrawerListItemContainer extends React.Component {
    
    componentDidMount() {
        this.props.fetchReclamationDemandesEnlevement(this.props.reclamationId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.props.fetchReclamationDemandesEnlevement(this.props.reclamationId);
        }
    }

    render() {

        let { nbReclamations } = this.props;

        if (!this.props.isLoading && nbReclamations === 0) {
            return null;
        }

        return (
            <ReclamationDrawerListItemWithLoader
                isLoading={this.props.isLoading}
                {...this.props}
                title={`Demandes d'enlèvement client en cours (${nbReclamations})`}

            />
        );
    }
}

DemandesEnlevementDrawerListItemContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.demandesEnlevement.isLoading,
    nbReclamations: state.reclamation.details.demandesEnlevement.items.length
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationDemandesEnlevement: (reclamationId) => dispatch(fetchReclamationDemandesEnlevement(reclamationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(DemandesEnlevementDrawerListItemContainer);